<footer class="main-footer">
  <strong>Copyright  &copy; 2020-2021 HenosisTech, Designed and Developed by<a href="http://www.henosistech.com" target="_blank">  Henosis Tech Pvt Ltd</a>.</strong>
  All rights reserved.
 
</footer>
